export function fetchApiStatuses(state, { page, sort, filter }) {
  return {
    ...state,
    apiStatuses: {
      ...state.apiStatuses,
      currentPage: page,
      sort: sort || state.apiStatuses.sort,
      filter: filter || state.apiStatuses.filter,
    },
  };
}

export function fetchApiStatusesSuccess(state, apiStatuses) {
  return {
    ...state,
    apiStatuses: {
      ...state.apiStatuses,
      numberOfPages: apiStatuses.numberOfPages,
      count: apiStatuses.count,
      items: apiStatuses.items,
    },
  };
}

export function fetchApiStatusesAllCountSuccess(state, payload) {
  return {
    ...state,
    apiStatuses: {
      ...state.apiStatuses,
      countOfAll: payload ? payload.count : 0,
    },
  };
}

export function updateApiStatus(state, { placementId }) {
  const placementIndex = state.apiStatuses.items.findIndex(x => x._id === placementId);
  const placement = state.apiStatuses.items[placementIndex];
  if (!placement) {
    return state;
  }
  return {
    ...state,
    apiStatuses: {
      ...state.apiStatuses,
      items: [
        ...state.apiStatuses.items.slice(0, placementIndex),
        {
          ...placement,
          isLoading: true,
        },
        ...state.apiStatuses.items.slice(placementIndex + 1),
      ],
    },
  };
}

export function updateApiStatusSuccess(state, { placementId, apiStatus }) {
  const placementIndex = state.apiStatuses.items.findIndex(x => x._id === placementId);
  const placement = state.apiStatuses.items[placementIndex];
  if (!placement) {
    return state;
  }
  return {
    ...state,
    apiStatuses: {
      ...state.apiStatuses,
      items: [
        ...state.apiStatuses.items.slice(0, placementIndex),
        {
          ...placement,
          apiStatus,
          isLoading: false,
        },
        ...state.apiStatuses.items.slice(placementIndex + 1),
      ],
    },
  };
}

export function updateApiStatusFail(state, { placementId }) {
  const placementIndex = state.apiStatuses.items.findIndex(x => x._id === placementId);
  const placement = state.apiStatuses.items[placementIndex];
  if (!placement) {
    return state;
  }
  return {
    ...state,
    apiStatuses: {
      ...state.apiStatuses,
      items: [
        ...state.apiStatuses.items.slice(0, placementIndex),
        {
          ...placement,
          isLoading: false,
        },
        ...state.apiStatuses.items.slice(placementIndex + 1),
      ],
    },
  };
}

export function updateApiStatusFromSocket(state, { placementId }) {
  const placementIndex = state.apiStatuses.items.findIndex(x => x._id === placementId);
  const placement = state.apiStatuses.items[placementIndex];
  if (!placement) {
    return state;
  }
  return {
    ...state,
    apiStatuses: {
      ...state.apiStatuses,
      items: [
        ...state.apiStatuses.items.slice(0, placementIndex),
        {
          ...placement,
          apiStatus: 'pending',
        },
        ...state.apiStatuses.items.slice(placementIndex + 1),
      ],
    },
  };
}

export function updateHeaderBadge(state, { isThereNewApiStatus }) {
  return {
    ...state,
    apiStatuses: {
      ...state.apiStatuses,
      isThereNewApiStatus,
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/apiStatuses.js
 **/